import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, nextTick, ref, watch } from 'vue'

import { assertNotNull } from '@/helpers/typing'
import { getImage, QuestionnaireView } from '@/models/onboarding'
import type {
  OptionsPage,
  QuestionnaireFormOption,
} from '@/models/onboarding.types'

import Layout from '../Layout.vue'
import OptionsBody from './OptionsBody.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'Options',
  props: {
    view: {}
  },
  setup(__props: any) {

const props = __props

const page = computed(() => {
  return props.view.currentPage as OptionsPage
})

const selectedOptions = ref<string[]>([])

watch(selectedOptions, (newValue) => {
  if (page.value.multipleOptions) {
    props.view.setCurrentChoice(newValue)
  } else {
    // `selectedOptions` is an array to make it easier
    // to handle multiple-option pages, but if this
    // is not a multi-option page, then `selectedOptions`
    // should only have one item.
    props.view.setCurrentChoice(newValue[0])
  }
})

const options = computed(() => {
  // Remove the `skip` option. We handle it differently than the other options.
  return page.value.options.filter((option) => option.type !== 'skip')
})

const skipOption = computed(() => {
  return page.value.options.find(
    (option) => typeof option !== 'string' && option.type === 'skip',
  ) as QuestionnaireFormOption | undefined
})

const image = computed(() => {
  if (!page.value.image) {
    return
  }

  return getImage(page.value.image.src)
})

/**
 * Set `selectedOptions` to the value of the `skipOption`,
 * and navigate to the next page.
 */
async function skip(): Promise<void> {
  selectedOptions.value = [assertNotNull(skipOption.value?.label)]
  // Wait for `watch`.
  await nextTick()

  await props.view.goNextPage()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Layout, {
    id: page.value.id,
    class: "onboarding-options",
    title: page.value.title,
    subtitle: page.value.subtitle,
    scrollDefaultSlot: true,
    reverseTitleSubtitle: true
  }, {
    default: _withCtx(() => [
      _createVNode(OptionsBody, {
        modelValue: selectedOptions.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedOptions).value = $event)),
        page: page.value,
        options: options.value,
        "skip-option": skipOption.value,
        "image-src": image.value,
        onSkip: skip
      }, null, 8, ["modelValue", "page", "options", "skip-option", "image-src"])
    ]),
    _: 1
  }, 8, ["id", "title", "subtitle"]))
}
}

})